import React, { FC } from "react"

import AnchorLink from "@components/AnchorLink/AnchorLink"

import "./FloatingSidebarNav.scss"

const FloatingSidebarNav: FC<{
  activeItemTitle?: string
  items: {
    title: string,
    permalink: string,
  }[]
}> = ({
  activeItemTitle,
  items,
}) => {
    return (
      <nav className="FloatingSidebarNav">
        <ul>
          {items.map(({ title, permalink }) => (
            <li key={title}>
              <AnchorLink
                className={activeItemTitle === title ? "active" : ""}
                href={permalink}
              >
                {title}
              </AnchorLink>
            </li>
          ))}
        </ul>
      </nav>
    )
  }

export default FloatingSidebarNav
